// extracted by mini-css-extract-plugin
module.exports = {"canvas":"PreviewEditor_canvas__10ceg","round":"PreviewEditor_round__3L4QE"};